import _ from 'underscore';
import Backbone from 'backbone';

export default Backbone.Model.extend({
  defaults: {
    combineValues: false,
    mandatoryRegisterNumber: [],
    mandatoryHolderNumber: [],

    showRegisterNumberField: false,
    showCompanyHolderField: false,

    companyLegalForm: '',
    vatNumber: '',
    registrationNumber: '',
    companyHolder: ''
  },

  initialize: function() {
    this.bindEvents();
  },

  bindEvents: function() {
    this.on('change:companyLegalForm', this.onChangeCompanyLegalForm);
    this.on('change:vatNumber', this.onVatNumberChange);
    this.on('change:registrationNumber', this.onChangeRegistrationNumber);
  },

  onChangeRegistrationNumber: function(model, value) {
    model.set('registrationNumber', value.replace(/ /g, ''));
  },

  onChangeCompanyLegalForm: function(model, value) {
    model.set(
      'showRegisterNumberField',
      model.get('combineValues') === false &&
        _.indexOf(model.get('mandatoryRegisterNumber'), value) !== -1
    );
    model.set(
      'showCompanyHolderField',
      _.indexOf(model.get('mandatoryHolderNumber'), value) !== -1
    );
  },

  onVatNumberChange: function(model, value) {
    const trimmedValue = value.replace(/ /g, '').toUpperCase();

    model.set('vatNumber', trimmedValue);
    if (model.get('combineValues')) {
      model.set('registrationNumber', trimmedValue);
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/b2b/businessSpecificFormModel.js
 **/